/**
 * @generated SignedSource<<ec429a17fe399cadb365010b70e4bf26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AggregateLevel = "YEAR" | "MONTH" | "DAY" | "%future added value";
export type FinancialAggregatedNumber = "actualRevenue" | "billableActualTimeAndExpenses" | "nonBillableActualTimeAndExpenses" | "allActualTimeAndExpenses" | "actualCost" | "actualProfit" | "actualRevenueProfit" | "actualMargin" | "actualRevenueMargin" | "plannedRevenue" | "billablePlannedTimeAndExpenses" | "nonBillablePlannedTimeAndExpenses" | "allPlannedTimeAndExpenses" | "plannedCost" | "plannedProfit" | "plannedRevenueProfit" | "plannedMargin" | "plannedRevenueMargin" | "remainingRevenue" | "billableForecastTimeAndExpensesToComplete" | "nonBillableForecastTimeAndExpensesToComplete" | "allForecastTimeAndExpensesToComplete" | "remainingCost" | "forecastCostToComplete" | "remainingProfit" | "forecastProfitToComplete" | "forecastRevenueProfitToComplete" | "remainingMargin" | "forecastMarginToComplete" | "forecastRevenueMarginToComplete" | "forecastRevenue" | "billableTotalTimeAndExpensesAtCompletion" | "nonBillableTotalTimeAndExpensesAtCompletion" | "allTotalTimeAndExpensesAtCompletion" | "forecastCost" | "totalCostAtCompletion" | "forecastProfit" | "totalProfitAtCompletion" | "totalRevenueProfitAtCompletion" | "forecastMargin" | "totalMarginAtCompletion" | "totalRevenueMarginAtCompletion" | "baselineRevenue" | "baselineTimeAndExpenses" | "baselineCost" | "baselineProfit" | "baselineMargin" | "baselineVsActualRevenue" | "baselineVsActualRevenueRecognition" | "baselineVsBillableActualTimeAndExpenses" | "baselineVsActualCost" | "baselineVsActualProfit" | "baselineVsActualMargin" | "baselineVsActualRevenueProfit" | "baselineVsActualRevenueMargin" | "baselineVsForecastRevenue" | "baselineVsBillableTotalTimeAndExpensesAtCompletion" | "baselineVsAllActualValueOfService" | "baselineVsAllProjectedValueOfService" | "estimatedVsAllActualValueOfService" | "estimatedVsAllProjectedValueOfService" | "baselineVsForecastCost" | "baselineVsTotalCostAtCompletion" | "baselineVsTotalRevenueAtCompletion" | "baselineVsForecastProfit" | "baselineVsTotalProfitAtCompletion" | "baselineVsTotalMarginAtCompletion" | "baselineVsTotalRevenueProfitAtCompletion" | "baselineVsTotalRevenueMarginAtCompletion" | "baselineMinutes" | "planVsActualRevenue" | "planVsActualRevenueRecognition" | "planVsBillableActualTimeAndExpenses" | "planVsActualCost" | "planVsActualProfit" | "planVsActualMargin" | "planVsActualRevenueProfit" | "planVsActualRevenueMargin" | "planVsForecastRevenue" | "planVsForecastCost" | "planVsForecastProfit" | "planVsTotalBillableTimeAndExpensesAtCompletion" | "planVsTotalRevenueAtCompletion" | "planVsTotalCostAtCompletion" | "planVsTotalMarginAtCompletion" | "planVsTotalProfitAtCompletion" | "planVsTotalRevenueMarginAtCompletion" | "planVsTotalRevenueProfitAtCompletion" | "recognitionLockedRevenue" | "registeredMinutes" | "billableActualMinutes" | "nonBillableActualMinutes" | "remainingMinutes" | "forecastTimeToComplete" | "forecastMinutes" | "totalTimeAtCompletion" | "scopeApprovedMinutes" | "scopeTotalMinutes" | "allocationMinutes" | "invoiced" | "paid" | "accruedDeferred" | "baselineVsRegisteredMinutes" | "baselineVsForecastMinutes" | "baselineVsTotalTimeAtCompletion" | "registeredVsScopeApprovedMinutes" | "scopeApprovedVsRegisteredMinutes" | "forecastVsScopeApprovedMinutes" | "totalTimeAtCompletionVsScopeApprovedMinutes" | "scopeApprovedVsForecastMinutes" | "scopeApprovedVsTotalTimeAtCompletion" | "retainerPeriodTargetMinutes" | "retainerPeriodTargetPrice" | "billableTime" | "recognitionPercentage" | "recognitionAmount" | "surplus" | "surplusPercentage" | "estimatedCost" | "recognitionProfit" | "recognitionProfitPercentage" | "recognitionActualProfit" | "recognitionActualProfitPercentage" | "recognitionLockedProfit" | "recognitionLockedProfitPercentage" | "recognitionForecastRevenue" | "totalRevenueRecognition" | "estimatedCostPercentage" | "expenseRevenuePercentage" | "expenseCostPercentage" | "recognitionOpenRevenue" | "actualOpenRevenue" | "actualLockedRevenue" | "totalActualRevenueRecognition" | "forecastOpenRevenueToComplete" | "forecastLockedRevenueToComplete" | "totalForecastRevenueToComplete" | "suggestedRevenue" | "suggestedRevenuePercentage" | "suggestedProfit" | "suggestedProfitPercentage" | "projectedTotalRevenueVsProjectedTotalBillableValueOfService" | "projectedTotalRevenueVsProjectedTotalValueOfService" | "retainerPeriodRolloverMinutes" | "retainerPeriodRolloverPrice" | "%future added value";
export type GLOBAL_FILTER_CONTEXT = "PROJECTS" | "PEOPLE" | "TASKS" | "TIME_REGS" | "INVOICES" | "SKILLS" | "LABELS" | "PLACEHOLDERS" | "RESOURCES" | "%future added value";
export type GLOBAL_FILTER_FIELD = "COMPANY_TASK_ID" | "NAME" | "STATUS" | "PROJECT_STATUS" | "PROJECT_GROUP_STATUS" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_GROUP_SPRINT" | "DESCRIPTION" | "REMAINING" | "TIME_REGS" | "FORECAST" | "TASK_APPROVED" | "START_DATE" | "START_DATE_PROJECT" | "END_DATE" | "END_DATE_PROJECT" | "START_DATE_TIME_REG" | "PHASE_TIME_REG" | "END_DATE_TIME_REG" | "PROJECT_TIME_REG" | "ROLE_TIME_REG" | "TEAM_TIME_REG" | "DEPARTMENT_TIME_REG" | "INTERNAL_TIME_REG" | "TIME_OFF_TIME_REG" | "BILLABLE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_TASK_TIME_REG" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "PERSON_TIME_REG" | "CLIENT_TIME_REG" | "SPRINT_TIME_REG" | "LABEL_TIME_REG" | "TASK_TIME_REG" | "CREATED_AT" | "WITH_TIME_REG" | "WITH_TASKS" | "TASK" | "TASK_LEVEL" | "UPDATED_AT" | "SET_DONE_AT" | "ASSIGNED" | "ASSIGNED_SELF" | "OWNER" | "FOLLOWER" | "LABELS" | "PROJECT_LABELS" | "ROLE" | "PROJECT" | "PROJECT_PERSON" | "CLIENT" | "PROJECT_STAGE" | "BUG" | "BLOCKED" | "BILLABLE" | "HIGH_PRIORITY" | "STARRED" | "RECENT_TIME" | "RECENT_TASK_ACTIVITY" | "RECENT_ACTIVITY" | "PHASE_CATEGORY" | "SPRINT_CATEGORY" | "DEADLINE" | "TEAM_MEMBER" | "TEAM" | "PERMISSION_LEVEL" | "CLIENT_GUEST_USERS" | "DEPENDENCIES" | "SUB_TASKS" | "TASK_HIERARCHY" | "DEPARTMENT" | "PERSON" | "NO_CONTACT" | "APPROVAL_STATUS" | "INTERNAL_TIME" | "TIME_OFF" | "PROJECT_FOLLOWER" | "PROJECT_OWNER" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "RATE_CARD" | "CONTACT" | "INVOICED" | "SKILL" | "PRIORITY_LEVEL" | "PROJECT_GROUP" | "PROGRAM" | "FILTER_BY_TIME_REG_SETTINGS" | "BILL_TO" | "BILL_FROM" | "PROJECT_MANUAL_PROGRESS" | "RETAINER_PERIOD" | "PROJECT_WIN_CHANCE" | "CLIENT_CONTACT_CLIENT_ID" | "CLIENT_CONTACT_COMPANY_ID" | "CLIENT_CONTACT_ID" | "CLIENT_CONTACT_NAME" | "CLIENT_CONTACT_FIRST_NAME" | "CLIENT_CONTACT_LAST_NAME" | "CLIENT_CONTACT_EMAIL" | "CLIENT_CONTACT_STATUS" | "CLIENT_CONTACT_IS_GUEST_USER" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "IS" | "IS_NOT" | "IS_ALL" | "IS_NOT_ALL" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "LESS" | "LESS_OR_EQUAL" | "IN" | "NOT_IN" | "ALL_IN" | "NOT_ALL_IN" | "%future added value";
export type TaskSearchQueryType = {
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
};
export type GlobalSearchFilterType = {
  field?: GLOBAL_FILTER_FIELD | null;
  operator?: GLOBAL_FILTER_OPERATOR | null;
  value?: ReadonlyArray<string | null> | null;
  context?: GLOBAL_FILTER_CONTEXT | null;
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
  logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null;
};
export type DetailsPhaseLoader_Query$variables = {
  projectId: string;
  startYear: number;
  startMonth: number;
  startDay: number;
  endYear: number;
  endMonth: number;
  endDay: number;
  aggregateLevel: AggregateLevel;
  aggregate: FinancialAggregatedNumber;
  searchQuery?: TaskSearchQueryType | null;
  baselineRevenue: boolean;
  baselineCost: boolean;
  baselineProfit: boolean;
  billableActualTimeAndExpenses: boolean;
  actualCost: boolean;
  actualProfit: boolean;
  billablePlannedTimeAndExpenses: boolean;
  plannedCost: boolean;
  plannedProfit: boolean;
  billableForecastTimeAndExpensesToComplete: boolean;
  forecastCostToComplete: boolean;
  forecastProfitToComplete: boolean;
  billableTotalTimeAndExpensesAtCompletion: boolean;
  totalCostAtCompletion: boolean;
  totalProfitAtCompletion: boolean;
  planVsBillableActualTimeAndExpenses: boolean;
  planVsActualCost: boolean;
  planVsActualProfit: boolean;
  planVsTotalBillableTimeAndExpensesAtCompletion: boolean;
  planVsTotalCostAtCompletion: boolean;
  planVsTotalProfitAtCompletion: boolean;
  baselineVsBillableActualTimeAndExpenses: boolean;
  baselineVsActualCost: boolean;
  baselineVsActualProfit: boolean;
  baselineVsBillableTotalTimeAndExpensesAtCompletion: boolean;
  baselineVsTotalCostAtCompletion: boolean;
  baselineVsTotalProfitAtCompletion: boolean;
  invoiced: boolean;
  paid: boolean;
  baselineMinutes: boolean;
  baselineVsRegisteredMinutes: boolean;
  baselineVsTotalTimeAtCompletion: boolean;
  registeredMinutes: boolean;
  billableActualMinutes: boolean;
  nonBillableActualMinutes: boolean;
  scopeApprovedMinutes: boolean;
  registeredVsScopeApprovedMinutes: boolean;
  scopeApprovedVsRegisteredMinutes: boolean;
  forecastTimeToComplete: boolean;
  totalTimeAtCompletion: boolean;
  totalTimeAtCompletionVsScopeApprovedMinutes: boolean;
  scopeApprovedVsTotalTimeAtCompletion: boolean;
  baselineTimeAndExpenses: boolean;
  plannedRevenueMargin: boolean;
  plannedRevenueProfit: boolean;
  totalRevenueProfitAtCompletion: boolean;
  forecastRevenueProfitToComplete: boolean;
  actualRevenueProfit: boolean;
  baselineMargin: boolean;
  forecastRevenueMarginToComplete: boolean;
  totalForecastRevenueToComplete: boolean;
  actualRevenueMargin: boolean;
  totalActualRevenueRecognition: boolean;
  baselineVsActualMargin: boolean;
  baselineVsTotalRevenueAtCompletion: boolean;
  baselineVsTotalMarginAtCompletion: boolean;
  planVsActualMargin: boolean;
  planVsTotalRevenueAtCompletion: boolean;
  baselineVsActualRevenueMargin: boolean;
  baselineVsActualRevenueProfit: boolean;
  baselineVsTotalRevenueMarginAtCompletion: boolean;
  baselineVsTotalRevenueProfitAtCompletion: boolean;
  planVsActualRevenueMargin: boolean;
  planVsActualRevenueProfit: boolean;
  planVsTotalRevenueMarginAtCompletion: boolean;
  planVsTotalRevenueProfitAtCompletion: boolean;
  baselineVsActualRevenueRecognition: boolean;
  planVsActualRevenueRecognition: boolean;
};
export type DetailsPhaseLoader_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"DetailsPhaseLoader_viewer">;
  } | null;
};
export type DetailsPhaseLoader_Query = {
  variables: DetailsPhaseLoader_Query$variables;
  response: DetailsPhaseLoader_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actualCost"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actualProfit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actualRevenueMargin"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "actualRevenueProfit"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aggregate"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aggregateLevel"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineCost"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineMargin"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineMinutes"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineProfit"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineRevenue"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineTimeAndExpenses"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsActualCost"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsActualMargin"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsActualProfit"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsActualRevenueMargin"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsActualRevenueProfit"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsActualRevenueRecognition"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsBillableActualTimeAndExpenses"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsRegisteredMinutes"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsTotalCostAtCompletion"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsTotalMarginAtCompletion"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsTotalProfitAtCompletion"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsTotalRevenueAtCompletion"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsTotalRevenueMarginAtCompletion"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsTotalRevenueProfitAtCompletion"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "baselineVsTotalTimeAtCompletion"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billableActualMinutes"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billableActualTimeAndExpenses"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billableForecastTimeAndExpensesToComplete"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billablePlannedTimeAndExpenses"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billableTotalTimeAndExpensesAtCompletion"
},
v33 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDay"
},
v34 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endMonth"
},
v35 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endYear"
},
v36 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forecastCostToComplete"
},
v37 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forecastProfitToComplete"
},
v38 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forecastRevenueMarginToComplete"
},
v39 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forecastRevenueProfitToComplete"
},
v40 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forecastTimeToComplete"
},
v41 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "invoiced"
},
v42 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nonBillableActualMinutes"
},
v43 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paid"
},
v44 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsActualCost"
},
v45 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsActualMargin"
},
v46 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsActualProfit"
},
v47 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsActualRevenueMargin"
},
v48 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsActualRevenueProfit"
},
v49 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsActualRevenueRecognition"
},
v50 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsBillableActualTimeAndExpenses"
},
v51 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsTotalBillableTimeAndExpensesAtCompletion"
},
v52 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsTotalCostAtCompletion"
},
v53 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsTotalProfitAtCompletion"
},
v54 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsTotalRevenueAtCompletion"
},
v55 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsTotalRevenueMarginAtCompletion"
},
v56 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planVsTotalRevenueProfitAtCompletion"
},
v57 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plannedCost"
},
v58 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plannedProfit"
},
v59 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plannedRevenueMargin"
},
v60 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plannedRevenueProfit"
},
v61 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v62 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "registeredMinutes"
},
v63 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "registeredVsScopeApprovedMinutes"
},
v64 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scopeApprovedMinutes"
},
v65 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scopeApprovedVsRegisteredMinutes"
},
v66 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scopeApprovedVsTotalTimeAtCompletion"
},
v67 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v68 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDay"
},
v69 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startMonth"
},
v70 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startYear"
},
v71 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalActualRevenueRecognition"
},
v72 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalCostAtCompletion"
},
v73 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalForecastRevenueToComplete"
},
v74 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalProfitAtCompletion"
},
v75 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalRevenueProfitAtCompletion"
},
v76 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalTimeAtCompletion"
},
v77 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalTimeAtCompletionVsScopeApprovedMinutes"
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "details_phase_loader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"details_phase_loader\")"
},
v80 = {
  "kind": "Variable",
  "name": "aggregateLevel",
  "variableName": "aggregateLevel"
},
v81 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v82 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v83 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v84 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v85 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v86 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v87 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v89 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  (v88/*: any*/)
],
v90 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breakdownType",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v93 = {
  "items": [
    {
      "kind": "Variable",
      "name": "aggregates.0",
      "variableName": "aggregate"
    }
  ],
  "kind": "ListValue",
  "name": "aggregates"
},
v94 = {
  "kind": "Literal",
  "name": "filterRowsWithNoValues",
  "value": true
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v41/*: any*/),
      (v42/*: any*/),
      (v43/*: any*/),
      (v44/*: any*/),
      (v45/*: any*/),
      (v46/*: any*/),
      (v47/*: any*/),
      (v48/*: any*/),
      (v49/*: any*/),
      (v50/*: any*/),
      (v51/*: any*/),
      (v52/*: any*/),
      (v53/*: any*/),
      (v54/*: any*/),
      (v55/*: any*/),
      (v56/*: any*/),
      (v57/*: any*/),
      (v58/*: any*/),
      (v59/*: any*/),
      (v60/*: any*/),
      (v61/*: any*/),
      (v62/*: any*/),
      (v63/*: any*/),
      (v64/*: any*/),
      (v65/*: any*/),
      (v66/*: any*/),
      (v67/*: any*/),
      (v68/*: any*/),
      (v69/*: any*/),
      (v70/*: any*/),
      (v71/*: any*/),
      (v72/*: any*/),
      (v73/*: any*/),
      (v74/*: any*/),
      (v75/*: any*/),
      (v76/*: any*/),
      (v77/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DetailsPhaseLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v78/*: any*/),
          (v79/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "actualCost",
                "variableName": "actualCost"
              },
              {
                "kind": "Variable",
                "name": "actualProfit",
                "variableName": "actualProfit"
              },
              {
                "kind": "Variable",
                "name": "actualRevenueMargin",
                "variableName": "actualRevenueMargin"
              },
              {
                "kind": "Variable",
                "name": "actualRevenueProfit",
                "variableName": "actualRevenueProfit"
              },
              {
                "kind": "Variable",
                "name": "aggregate",
                "variableName": "aggregate"
              },
              (v80/*: any*/),
              {
                "kind": "Variable",
                "name": "baselineCost",
                "variableName": "baselineCost"
              },
              {
                "kind": "Variable",
                "name": "baselineMargin",
                "variableName": "baselineMargin"
              },
              {
                "kind": "Variable",
                "name": "baselineMinutes",
                "variableName": "baselineMinutes"
              },
              {
                "kind": "Variable",
                "name": "baselineProfit",
                "variableName": "baselineProfit"
              },
              {
                "kind": "Variable",
                "name": "baselineRevenue",
                "variableName": "baselineRevenue"
              },
              {
                "kind": "Variable",
                "name": "baselineTimeAndExpenses",
                "variableName": "baselineTimeAndExpenses"
              },
              {
                "kind": "Variable",
                "name": "baselineVsActualCost",
                "variableName": "baselineVsActualCost"
              },
              {
                "kind": "Variable",
                "name": "baselineVsActualMargin",
                "variableName": "baselineVsActualMargin"
              },
              {
                "kind": "Variable",
                "name": "baselineVsActualProfit",
                "variableName": "baselineVsActualProfit"
              },
              {
                "kind": "Variable",
                "name": "baselineVsActualRevenueMargin",
                "variableName": "baselineVsActualRevenueMargin"
              },
              {
                "kind": "Variable",
                "name": "baselineVsActualRevenueProfit",
                "variableName": "baselineVsActualRevenueProfit"
              },
              {
                "kind": "Variable",
                "name": "baselineVsActualRevenueRecognition",
                "variableName": "baselineVsActualRevenueRecognition"
              },
              {
                "kind": "Variable",
                "name": "baselineVsBillableActualTimeAndExpenses",
                "variableName": "baselineVsBillableActualTimeAndExpenses"
              },
              {
                "kind": "Variable",
                "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                "variableName": "baselineVsBillableTotalTimeAndExpensesAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "baselineVsRegisteredMinutes",
                "variableName": "baselineVsRegisteredMinutes"
              },
              {
                "kind": "Variable",
                "name": "baselineVsTotalCostAtCompletion",
                "variableName": "baselineVsTotalCostAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "baselineVsTotalMarginAtCompletion",
                "variableName": "baselineVsTotalMarginAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "baselineVsTotalProfitAtCompletion",
                "variableName": "baselineVsTotalProfitAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "baselineVsTotalRevenueAtCompletion",
                "variableName": "baselineVsTotalRevenueAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "baselineVsTotalRevenueMarginAtCompletion",
                "variableName": "baselineVsTotalRevenueMarginAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "baselineVsTotalRevenueProfitAtCompletion",
                "variableName": "baselineVsTotalRevenueProfitAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "baselineVsTotalTimeAtCompletion",
                "variableName": "baselineVsTotalTimeAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "billableActualMinutes",
                "variableName": "billableActualMinutes"
              },
              {
                "kind": "Variable",
                "name": "billableActualTimeAndExpenses",
                "variableName": "billableActualTimeAndExpenses"
              },
              {
                "kind": "Variable",
                "name": "billableForecastTimeAndExpensesToComplete",
                "variableName": "billableForecastTimeAndExpensesToComplete"
              },
              {
                "kind": "Variable",
                "name": "billablePlannedTimeAndExpenses",
                "variableName": "billablePlannedTimeAndExpenses"
              },
              {
                "kind": "Variable",
                "name": "billableTotalTimeAndExpensesAtCompletion",
                "variableName": "billableTotalTimeAndExpensesAtCompletion"
              },
              (v81/*: any*/),
              (v82/*: any*/),
              (v83/*: any*/),
              {
                "kind": "Variable",
                "name": "forecastCostToComplete",
                "variableName": "forecastCostToComplete"
              },
              {
                "kind": "Variable",
                "name": "forecastProfitToComplete",
                "variableName": "forecastProfitToComplete"
              },
              {
                "kind": "Variable",
                "name": "forecastRevenueMarginToComplete",
                "variableName": "forecastRevenueMarginToComplete"
              },
              {
                "kind": "Variable",
                "name": "forecastRevenueProfitToComplete",
                "variableName": "forecastRevenueProfitToComplete"
              },
              {
                "kind": "Variable",
                "name": "forecastTimeToComplete",
                "variableName": "forecastTimeToComplete"
              },
              {
                "kind": "Variable",
                "name": "invoiced",
                "variableName": "invoiced"
              },
              {
                "kind": "Variable",
                "name": "nonBillableActualMinutes",
                "variableName": "nonBillableActualMinutes"
              },
              {
                "kind": "Variable",
                "name": "paid",
                "variableName": "paid"
              },
              {
                "kind": "Variable",
                "name": "planVsActualCost",
                "variableName": "planVsActualCost"
              },
              {
                "kind": "Variable",
                "name": "planVsActualMargin",
                "variableName": "planVsActualMargin"
              },
              {
                "kind": "Variable",
                "name": "planVsActualProfit",
                "variableName": "planVsActualProfit"
              },
              {
                "kind": "Variable",
                "name": "planVsActualRevenueMargin",
                "variableName": "planVsActualRevenueMargin"
              },
              {
                "kind": "Variable",
                "name": "planVsActualRevenueProfit",
                "variableName": "planVsActualRevenueProfit"
              },
              {
                "kind": "Variable",
                "name": "planVsActualRevenueRecognition",
                "variableName": "planVsActualRevenueRecognition"
              },
              {
                "kind": "Variable",
                "name": "planVsBillableActualTimeAndExpenses",
                "variableName": "planVsBillableActualTimeAndExpenses"
              },
              {
                "kind": "Variable",
                "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
                "variableName": "planVsTotalBillableTimeAndExpensesAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "planVsTotalCostAtCompletion",
                "variableName": "planVsTotalCostAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "planVsTotalProfitAtCompletion",
                "variableName": "planVsTotalProfitAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "planVsTotalRevenueAtCompletion",
                "variableName": "planVsTotalRevenueAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "planVsTotalRevenueMarginAtCompletion",
                "variableName": "planVsTotalRevenueMarginAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "planVsTotalRevenueProfitAtCompletion",
                "variableName": "planVsTotalRevenueProfitAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "plannedCost",
                "variableName": "plannedCost"
              },
              {
                "kind": "Variable",
                "name": "plannedProfit",
                "variableName": "plannedProfit"
              },
              {
                "kind": "Variable",
                "name": "plannedRevenueMargin",
                "variableName": "plannedRevenueMargin"
              },
              {
                "kind": "Variable",
                "name": "plannedRevenueProfit",
                "variableName": "plannedRevenueProfit"
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              },
              {
                "kind": "Variable",
                "name": "registeredMinutes",
                "variableName": "registeredMinutes"
              },
              {
                "kind": "Variable",
                "name": "registeredVsScopeApprovedMinutes",
                "variableName": "registeredVsScopeApprovedMinutes"
              },
              {
                "kind": "Variable",
                "name": "scopeApprovedMinutes",
                "variableName": "scopeApprovedMinutes"
              },
              {
                "kind": "Variable",
                "name": "scopeApprovedVsRegisteredMinutes",
                "variableName": "scopeApprovedVsRegisteredMinutes"
              },
              {
                "kind": "Variable",
                "name": "scopeApprovedVsTotalTimeAtCompletion",
                "variableName": "scopeApprovedVsTotalTimeAtCompletion"
              },
              (v84/*: any*/),
              (v85/*: any*/),
              (v86/*: any*/),
              (v87/*: any*/),
              {
                "kind": "Variable",
                "name": "totalActualRevenueRecognition",
                "variableName": "totalActualRevenueRecognition"
              },
              {
                "kind": "Variable",
                "name": "totalCostAtCompletion",
                "variableName": "totalCostAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "totalForecastRevenueToComplete",
                "variableName": "totalForecastRevenueToComplete"
              },
              {
                "kind": "Variable",
                "name": "totalProfitAtCompletion",
                "variableName": "totalProfitAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "totalRevenueProfitAtCompletion",
                "variableName": "totalRevenueProfitAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "totalTimeAtCompletion",
                "variableName": "totalTimeAtCompletion"
              },
              {
                "kind": "Variable",
                "name": "totalTimeAtCompletionVsScopeApprovedMinutes",
                "variableName": "totalTimeAtCompletionVsScopeApprovedMinutes"
              }
            ],
            "kind": "FragmentSpread",
            "name": "DetailsPhaseLoader_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v61/*: any*/),
      (v70/*: any*/),
      (v69/*: any*/),
      (v68/*: any*/),
      (v35/*: any*/),
      (v34/*: any*/),
      (v33/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v67/*: any*/),
      (v10/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v29/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v31/*: any*/),
      (v57/*: any*/),
      (v58/*: any*/),
      (v30/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/),
      (v32/*: any*/),
      (v72/*: any*/),
      (v74/*: any*/),
      (v50/*: any*/),
      (v44/*: any*/),
      (v46/*: any*/),
      (v51/*: any*/),
      (v52/*: any*/),
      (v53/*: any*/),
      (v18/*: any*/),
      (v12/*: any*/),
      (v14/*: any*/),
      (v19/*: any*/),
      (v21/*: any*/),
      (v23/*: any*/),
      (v41/*: any*/),
      (v43/*: any*/),
      (v8/*: any*/),
      (v20/*: any*/),
      (v27/*: any*/),
      (v62/*: any*/),
      (v28/*: any*/),
      (v42/*: any*/),
      (v64/*: any*/),
      (v63/*: any*/),
      (v65/*: any*/),
      (v40/*: any*/),
      (v76/*: any*/),
      (v77/*: any*/),
      (v66/*: any*/),
      (v11/*: any*/),
      (v59/*: any*/),
      (v60/*: any*/),
      (v75/*: any*/),
      (v39/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v38/*: any*/),
      (v73/*: any*/),
      (v2/*: any*/),
      (v71/*: any*/),
      (v13/*: any*/),
      (v24/*: any*/),
      (v22/*: any*/),
      (v45/*: any*/),
      (v54/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v47/*: any*/),
      (v48/*: any*/),
      (v55/*: any*/),
      (v56/*: any*/),
      (v17/*: any*/),
      (v49/*: any*/)
    ],
    "kind": "Operation",
    "name": "DetailsPhaseLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v78/*: any*/),
          (v79/*: any*/),
          (v88/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": (v89/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "internalId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v90/*: any*/),
                  (v81/*: any*/),
                  (v82/*: any*/),
                  (v83/*: any*/),
                  (v84/*: any*/),
                  (v85/*: any*/),
                  (v86/*: any*/),
                  (v87/*: any*/)
                ],
                "concreteType": "PhaseFinancialBreakdown",
                "kind": "LinkedField",
                "name": "phaseFinancialBreakdown",
                "plural": true,
                "selections": [
                  (v91/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseType",
                    "kind": "LinkedField",
                    "name": "phase",
                    "plural": false,
                    "selections": [
                      (v88/*: any*/),
                      (v92/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinancialNumbers",
                    "kind": "LinkedField",
                    "name": "financialNumbers",
                    "plural": false,
                    "selections": [
                      {
                        "condition": "baselineRevenue",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineRevenue",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "billableActualTimeAndExpenses",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billableActualTimeAndExpenses",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "actualCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actualCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "actualProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actualProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "billablePlannedTimeAndExpenses",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billablePlannedTimeAndExpenses",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "plannedCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "plannedCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "plannedProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "plannedProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "billableForecastTimeAndExpensesToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billableForecastTimeAndExpensesToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "forecastCostToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forecastCostToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "forecastProfitToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forecastProfitToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "billableTotalTimeAndExpensesAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billableTotalTimeAndExpensesAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalCostAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalCostAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalProfitAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalProfitAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsBillableActualTimeAndExpenses",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsBillableActualTimeAndExpenses",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsActualCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsActualCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsActualProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsActualProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsTotalBillableTimeAndExpensesAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsTotalCostAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsTotalCostAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsTotalProfitAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsTotalProfitAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsBillableActualTimeAndExpenses",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsBillableActualTimeAndExpenses",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsActualCost",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsActualCost",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsActualProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsActualProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsTotalCostAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsTotalCostAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsTotalProfitAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsTotalProfitAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "invoiced",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "invoiced",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "paid",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "paid",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsRegisteredMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsRegisteredMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsTotalTimeAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsTotalTimeAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "registeredMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "registeredMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "billableActualMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "billableActualMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "nonBillableActualMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "nonBillableActualMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "scopeApprovedMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scopeApprovedMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "registeredVsScopeApprovedMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "registeredVsScopeApprovedMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "scopeApprovedVsRegisteredMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scopeApprovedVsRegisteredMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "forecastTimeToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forecastTimeToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalTimeAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalTimeAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalTimeAtCompletionVsScopeApprovedMinutes",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalTimeAtCompletionVsScopeApprovedMinutes",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "scopeApprovedVsTotalTimeAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scopeApprovedVsTotalTimeAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineTimeAndExpenses",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineTimeAndExpenses",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "plannedRevenueProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "plannedRevenueProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "plannedRevenueMargin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "plannedRevenueMargin",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalRevenueProfitAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalRevenueProfitAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "forecastRevenueProfitToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forecastRevenueProfitToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "actualRevenueProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actualRevenueProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineMargin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineMargin",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "forecastRevenueMarginToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forecastRevenueMarginToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalForecastRevenueToComplete",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalForecastRevenueToComplete",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "actualRevenueMargin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actualRevenueMargin",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "totalActualRevenueRecognition",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalActualRevenueRecognition",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsActualMargin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsActualMargin",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsTotalRevenueAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsTotalRevenueAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsTotalMarginAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsTotalMarginAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsActualMargin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsActualMargin",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsTotalRevenueAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsTotalRevenueAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsActualRevenueMargin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsActualRevenueMargin",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsActualRevenueProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsActualRevenueProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsTotalRevenueMarginAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsTotalRevenueMarginAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsTotalRevenueProfitAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsTotalRevenueProfitAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsActualRevenueMargin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsActualRevenueMargin",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsActualRevenueProfit",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsActualRevenueProfit",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsTotalRevenueMarginAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsTotalRevenueMarginAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsTotalRevenueProfitAtCompletion",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsTotalRevenueProfitAtCompletion",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "baselineVsActualRevenueRecognition",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineVsActualRevenueRecognition",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "planVsActualRevenueRecognition",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planVsActualRevenueRecognition",
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": (v89/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "addAccumulatedNumbers",
                    "value": true
                  },
                  (v80/*: any*/),
                  (v93/*: any*/),
                  (v90/*: any*/),
                  (v81/*: any*/),
                  (v82/*: any*/),
                  (v83/*: any*/),
                  (v94/*: any*/),
                  (v84/*: any*/),
                  (v85/*: any*/),
                  (v86/*: any*/),
                  (v87/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "aggregatedFinancialNumbers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v80/*: any*/),
                  (v93/*: any*/),
                  (v90/*: any*/),
                  (v81/*: any*/),
                  (v82/*: any*/),
                  (v83/*: any*/),
                  (v94/*: any*/),
                  (v84/*: any*/),
                  (v85/*: any*/),
                  (v86/*: any*/),
                  (v87/*: any*/)
                ],
                "concreteType": "AggregatedPhaseFinancialBreakdown",
                "kind": "LinkedField",
                "name": "aggregatedPhaseFinancialBreakdown",
                "plural": true,
                "selections": [
                  (v91/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseType",
                    "kind": "LinkedField",
                    "name": "phase",
                    "plural": false,
                    "selections": [
                      (v88/*: any*/),
                      (v92/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startYear",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startMonth",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDay",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aggregatedFinancialNumbers",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v88/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "438279ff5383e8532241746b3c16b0a4",
    "id": null,
    "metadata": {},
    "name": "DetailsPhaseLoader_Query",
    "operationKind": "query",
    "text": "query DetailsPhaseLoader_Query(\n  $projectId: ID!\n  $startYear: Int!\n  $startMonth: Int!\n  $startDay: Int!\n  $endYear: Int!\n  $endMonth: Int!\n  $endDay: Int!\n  $aggregateLevel: AggregateLevel!\n  $aggregate: FinancialAggregatedNumber!\n  $searchQuery: TaskSearchQueryType\n  $baselineRevenue: Boolean!\n  $baselineCost: Boolean!\n  $baselineProfit: Boolean!\n  $billableActualTimeAndExpenses: Boolean!\n  $actualCost: Boolean!\n  $actualProfit: Boolean!\n  $billablePlannedTimeAndExpenses: Boolean!\n  $plannedCost: Boolean!\n  $plannedProfit: Boolean!\n  $billableForecastTimeAndExpensesToComplete: Boolean!\n  $forecastCostToComplete: Boolean!\n  $forecastProfitToComplete: Boolean!\n  $billableTotalTimeAndExpensesAtCompletion: Boolean!\n  $totalCostAtCompletion: Boolean!\n  $totalProfitAtCompletion: Boolean!\n  $planVsBillableActualTimeAndExpenses: Boolean!\n  $planVsActualCost: Boolean!\n  $planVsActualProfit: Boolean!\n  $planVsTotalBillableTimeAndExpensesAtCompletion: Boolean!\n  $planVsTotalCostAtCompletion: Boolean!\n  $planVsTotalProfitAtCompletion: Boolean!\n  $baselineVsBillableActualTimeAndExpenses: Boolean!\n  $baselineVsActualCost: Boolean!\n  $baselineVsActualProfit: Boolean!\n  $baselineVsBillableTotalTimeAndExpensesAtCompletion: Boolean!\n  $baselineVsTotalCostAtCompletion: Boolean!\n  $baselineVsTotalProfitAtCompletion: Boolean!\n  $invoiced: Boolean!\n  $paid: Boolean!\n  $baselineMinutes: Boolean!\n  $baselineVsRegisteredMinutes: Boolean!\n  $baselineVsTotalTimeAtCompletion: Boolean!\n  $registeredMinutes: Boolean!\n  $billableActualMinutes: Boolean!\n  $nonBillableActualMinutes: Boolean!\n  $scopeApprovedMinutes: Boolean!\n  $registeredVsScopeApprovedMinutes: Boolean!\n  $scopeApprovedVsRegisteredMinutes: Boolean!\n  $forecastTimeToComplete: Boolean!\n  $totalTimeAtCompletion: Boolean!\n  $totalTimeAtCompletionVsScopeApprovedMinutes: Boolean!\n  $scopeApprovedVsTotalTimeAtCompletion: Boolean!\n  $baselineTimeAndExpenses: Boolean!\n  $plannedRevenueMargin: Boolean!\n  $plannedRevenueProfit: Boolean!\n  $totalRevenueProfitAtCompletion: Boolean!\n  $forecastRevenueProfitToComplete: Boolean!\n  $actualRevenueProfit: Boolean!\n  $baselineMargin: Boolean!\n  $forecastRevenueMarginToComplete: Boolean!\n  $totalForecastRevenueToComplete: Boolean!\n  $actualRevenueMargin: Boolean!\n  $totalActualRevenueRecognition: Boolean!\n  $baselineVsActualMargin: Boolean!\n  $baselineVsTotalRevenueAtCompletion: Boolean!\n  $baselineVsTotalMarginAtCompletion: Boolean!\n  $planVsActualMargin: Boolean!\n  $planVsTotalRevenueAtCompletion: Boolean!\n  $baselineVsActualRevenueMargin: Boolean!\n  $baselineVsActualRevenueProfit: Boolean!\n  $baselineVsTotalRevenueMarginAtCompletion: Boolean!\n  $baselineVsTotalRevenueProfitAtCompletion: Boolean!\n  $planVsActualRevenueMargin: Boolean!\n  $planVsActualRevenueProfit: Boolean!\n  $planVsTotalRevenueMarginAtCompletion: Boolean!\n  $planVsTotalRevenueProfitAtCompletion: Boolean!\n  $baselineVsActualRevenueRecognition: Boolean!\n  $planVsActualRevenueRecognition: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"details_phase_loader\")\n    ...DetailsPhaseLoader_viewer_1ht80H\n    id\n  }\n}\n\nfragment DetailsPhaseLoader_viewer_1ht80H on Viewer {\n  id\n  company {\n    currency\n    id\n  }\n  project(internalId: $projectId) {\n    phaseFinancialBreakdown(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true) {\n      breakdownType\n      phase {\n        id\n        name\n      }\n      financialNumbers {\n        baselineRevenue @include(if: $baselineRevenue)\n        baselineCost @include(if: $baselineCost)\n        baselineProfit @include(if: $baselineProfit)\n        billableActualTimeAndExpenses @include(if: $billableActualTimeAndExpenses)\n        actualCost @include(if: $actualCost)\n        actualProfit @include(if: $actualProfit)\n        billablePlannedTimeAndExpenses @include(if: $billablePlannedTimeAndExpenses)\n        plannedCost @include(if: $plannedCost)\n        plannedProfit @include(if: $plannedProfit)\n        billableForecastTimeAndExpensesToComplete @include(if: $billableForecastTimeAndExpensesToComplete)\n        forecastCostToComplete @include(if: $forecastCostToComplete)\n        forecastProfitToComplete @include(if: $forecastProfitToComplete)\n        billableTotalTimeAndExpensesAtCompletion @include(if: $billableTotalTimeAndExpensesAtCompletion)\n        totalCostAtCompletion @include(if: $totalCostAtCompletion)\n        totalProfitAtCompletion @include(if: $totalProfitAtCompletion)\n        planVsBillableActualTimeAndExpenses @include(if: $planVsBillableActualTimeAndExpenses)\n        planVsActualCost @include(if: $planVsActualCost)\n        planVsActualProfit @include(if: $planVsActualProfit)\n        planVsTotalBillableTimeAndExpensesAtCompletion @include(if: $planVsTotalBillableTimeAndExpensesAtCompletion)\n        planVsTotalCostAtCompletion @include(if: $planVsTotalCostAtCompletion)\n        planVsTotalProfitAtCompletion @include(if: $planVsTotalProfitAtCompletion)\n        baselineVsBillableActualTimeAndExpenses @include(if: $baselineVsBillableActualTimeAndExpenses)\n        baselineVsActualCost @include(if: $baselineVsActualCost)\n        baselineVsActualProfit @include(if: $baselineVsActualProfit)\n        baselineVsBillableTotalTimeAndExpensesAtCompletion @include(if: $baselineVsBillableTotalTimeAndExpensesAtCompletion)\n        baselineVsTotalCostAtCompletion @include(if: $baselineVsTotalCostAtCompletion)\n        baselineVsTotalProfitAtCompletion @include(if: $baselineVsTotalProfitAtCompletion)\n        invoiced @include(if: $invoiced)\n        paid @include(if: $paid)\n        baselineMinutes @include(if: $baselineMinutes)\n        baselineVsRegisteredMinutes @include(if: $baselineVsRegisteredMinutes)\n        baselineVsTotalTimeAtCompletion @include(if: $baselineVsTotalTimeAtCompletion)\n        registeredMinutes @include(if: $registeredMinutes)\n        billableActualMinutes @include(if: $billableActualMinutes)\n        nonBillableActualMinutes @include(if: $nonBillableActualMinutes)\n        scopeApprovedMinutes @include(if: $scopeApprovedMinutes)\n        registeredVsScopeApprovedMinutes @include(if: $registeredVsScopeApprovedMinutes)\n        scopeApprovedVsRegisteredMinutes @include(if: $scopeApprovedVsRegisteredMinutes)\n        forecastTimeToComplete @include(if: $forecastTimeToComplete)\n        totalTimeAtCompletion @include(if: $totalTimeAtCompletion)\n        totalTimeAtCompletionVsScopeApprovedMinutes @include(if: $totalTimeAtCompletionVsScopeApprovedMinutes)\n        scopeApprovedVsTotalTimeAtCompletion @include(if: $scopeApprovedVsTotalTimeAtCompletion)\n        baselineTimeAndExpenses @include(if: $baselineTimeAndExpenses)\n        plannedRevenueProfit @include(if: $plannedRevenueProfit)\n        plannedRevenueMargin @include(if: $plannedRevenueMargin)\n        totalRevenueProfitAtCompletion @include(if: $totalRevenueProfitAtCompletion)\n        forecastRevenueProfitToComplete @include(if: $forecastRevenueProfitToComplete)\n        actualRevenueProfit @include(if: $actualRevenueProfit)\n        baselineMargin @include(if: $baselineMargin)\n        forecastRevenueMarginToComplete @include(if: $forecastRevenueMarginToComplete)\n        totalForecastRevenueToComplete @include(if: $totalForecastRevenueToComplete)\n        actualRevenueMargin @include(if: $actualRevenueMargin)\n        totalActualRevenueRecognition @include(if: $totalActualRevenueRecognition)\n        baselineVsActualMargin @include(if: $baselineVsActualMargin)\n        baselineVsTotalRevenueAtCompletion @include(if: $baselineVsTotalRevenueAtCompletion)\n        baselineVsTotalMarginAtCompletion @include(if: $baselineVsTotalMarginAtCompletion)\n        planVsActualMargin @include(if: $planVsActualMargin)\n        planVsTotalRevenueAtCompletion @include(if: $planVsTotalRevenueAtCompletion)\n        baselineVsActualRevenueMargin @include(if: $baselineVsActualRevenueMargin)\n        baselineVsActualRevenueProfit @include(if: $baselineVsActualRevenueProfit)\n        baselineVsTotalRevenueMarginAtCompletion @include(if: $baselineVsTotalRevenueMarginAtCompletion)\n        baselineVsTotalRevenueProfitAtCompletion @include(if: $baselineVsTotalRevenueProfitAtCompletion)\n        planVsActualRevenueMargin @include(if: $planVsActualRevenueMargin)\n        planVsActualRevenueProfit @include(if: $planVsActualRevenueProfit)\n        planVsTotalRevenueMarginAtCompletion @include(if: $planVsTotalRevenueMarginAtCompletion)\n        planVsTotalRevenueProfitAtCompletion @include(if: $planVsTotalRevenueProfitAtCompletion)\n        baselineVsActualRevenueRecognition @include(if: $baselineVsActualRevenueRecognition)\n        planVsActualRevenueRecognition @include(if: $planVsActualRevenueRecognition)\n      }\n    }\n    rateCard {\n      currency\n      id\n    }\n    aggregatedFinancialNumbers(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: [$aggregate], addAccumulatedNumbers: true, convertToProjectCurrency: true, filterRowsWithNoValues: true)\n    aggregatedPhaseFinancialBreakdown(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: [$aggregate], searchQuery: $searchQuery, convertToProjectCurrency: true, filterRowsWithNoValues: true) {\n      breakdownType\n      phase {\n        id\n        name\n        startYear\n        startMonth\n        startDay\n      }\n      aggregatedFinancialNumbers\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "60349c98fcd22bdce4288fad022a70f2";

export default node;
